import React, { useEffect, useState } from "react";
import { api, GOOGLE_START_URL } from "../api.js";
import { useApp, useAsync } from "../store.js";
import { ACC, CRIT } from "../lib/ui.js";

const AUTH_ERRORS: Record<string, string> = {
  domain_not_allowed: "That account isn't on the rever.vn domain.",
  not_allowlisted: "Your account isn't on the access list for this portal. Ask an admin to add you in code.",
  email_not_verified: "Your Google email isn't verified.",
  invalid_oauth_state: "Sign-in expired or was tampered — please try again.",
  no_id_token: "Google didn't return an identity token.",
  google_not_configured: "Google sign-in isn't configured on this instance yet.",
};

export function Login() {
  const { setSession } = useApp();
  const cfg = useAsync(() => api.authConfig(), []);
  const [email, setEmail] = useState("thanh@rever.vn");
  const [name, setName] = useState("Thanh");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search).get("auth_error");
    if (p) {
      setErr(AUTH_ERRORS[p] ?? `Sign-in failed: ${p}`);
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try { setSession(await api.devLogin(email, name)); }
    catch (e) { setErr((e as Error).message); }
    finally { setBusy(false); }
  };

  const googleOn = cfg.data?.googleConfigured;
  const devOn = cfg.data?.devLogin;

  return (
    <div style={{ height: "100vh", display: "grid", placeItems: "center", background: "#161826", color: "#e9e9ed", fontFamily: "var(--font-body)" }}>
      <div style={{ width: "370px", background: "#1c1e2b", border: "1px solid #292b31", borderRadius: "14px", padding: "26px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "18px" }}>
          <div style={{ width: "30px", height: "30px", borderRadius: "8px", border: "1px solid #968ae0", display: "grid", placeItems: "center", color: "#b5abfc" }}>
            <i className="ph ph-chart-donut" style={{ fontSize: "16px" }} />
          </div>
          <div>
            <div style={{ fontFamily: "var(--font-heading)", fontSize: "16px" }}>Rever Analytics</div>
            <div style={{ fontSize: "10px", color: "#75798c", letterSpacing: "0.06em", textTransform: "uppercase" }}>dashboard portal</div>
          </div>
        </div>

        <a
          href={googleOn ? GOOGLE_START_URL : undefined}
          aria-disabled={!googleOn}
          title={googleOn ? "Sign in with your @rever.vn Google account" : "Google OAuth not configured on this instance"}
          className="btn btn-secondary btn-block"
          style={{ opacity: googleOn ? 1 : 0.55, cursor: googleOn ? "pointer" : "not-allowed", justifyContent: "center", textDecoration: "none", pointerEvents: googleOn ? "auto" : "none" }}
        >
          <i className="ph ph-google-logo" /> Sign in with Google (@{cfg.data?.allowedDomain ?? "rever.vn"})
        </a>

        {err && (
          <div style={{ fontSize: "12px", color: "#e79a9a", marginTop: "12px", background: "rgba(215,107,107,.08)", border: "1px solid rgba(215,107,107,.3)", borderRadius: "8px", padding: "8px 10px" }}>
            <i className="ph ph-warning-circle" style={{ marginRight: "6px", color: CRIT }} />{err}
          </div>
        )}

        {devOn && (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", margin: "16px 0", color: "#595d6c", fontSize: "11px" }}>
              <div style={{ flex: 1, height: "1px", background: "#292b31" }} /> dev login <div style={{ flex: 1, height: "1px", background: "#292b31" }} />
            </div>
            <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <div className="field">
                <label>Email (@{cfg.data?.allowedDomain ?? "rever.vn"})</label>
                <input className="input" value={email} onChange={(e) => setEmail(e.target.value)} />
              </div>
              <div className="field">
                <label>Name</label>
                <input className="input" value={name} onChange={(e) => setName(e.target.value)} />
              </div>
              <button className="btn btn-primary btn-block" disabled={busy} style={{ borderColor: ACC, color: "#b5abfc", justifyContent: "center" }}>
                {busy ? "Signing in…" : "Continue"}
              </button>
            </form>
          </>
        )}

        <div style={{ fontSize: "10px", color: "#595d6c", marginTop: "14px", lineHeight: 1.5 }}>
          Access is an <strong style={{ color: "#9397ab" }}>allowlist maintained in code</strong>. Only listed @rever.vn accounts can sign in.
        </div>
      </div>
    </div>
  );
}
